<template>

  <div v-if="latLngs">

    <l-polygon
      ref="polygon"
      :lat-lngs="latLngs"
      :fill="false"
      :color="color"
      :weight="5"
      @ready="polygonReady"
    >
      <l-tooltip :options="{ permanent: true, interactive: true, opacity: 1.0, }" ref="tip">
        <div>
          <strong class="">{{feature.properties.ProviderName}}</strong>
          <div class="small">{{feature.properties.Location}}</div>
          <div class="small my-0">
            <div class="d-inline" v-if="feature.properties.Speeds_mbps">
              {{$helpers.formatSpeed(feature.properties.Speeds_mbps)}} -
            </div>
            {{feature.properties.Type}}
          </div>
          <v-btn v-if="providerLink"
                 color="accent"
                 x-small
                 depressed
                 block
                 tile @click="goToProvider(feature)">
            View Provider Service
          </v-btn>
        </div>
      </l-tooltip>
    </l-polygon>

  </div>

</template>

<script>
// import cloneDeep from 'lodash/cloneDeep';
import { GeoJSON } from 'leaflet';

const name = 'SelectedFeatureLayer';

export default {

  name,

  props: {

    color: {
      type: String,
      required: false,
      default: 'red',
    },

    showFeatureInfo: {
      type: Boolean,
      required: false,
      default: true,
    },

    providerLink: {
      type: Boolean,
      required: false,
      default: false,
    },

  },

  data() {
    return {
      map: null,
      polygonComponent: null,
    };
  },

  watch: {

    layer() {
      this.$nextTick(() => {
        if (this.layer) {
          this.$refs.polygon.mapObject.openTooltip(this.layer.getBounds().getCenter());
        }
      });
    },

    latLngs() {
      if (this.polygonComponent) {
        this.polygonComponent.bringToFront();
        this.centerWithinMap();
      }
    },

  },

  computed: {

    feature() {
      return this.$store.getters.selectedService;
    },

    layer() {
      return this.feature ? GeoJSON.geometryToLayer(this.feature) : null;
    },

    latLngs() {
      return this.layer ? this.layer.getLatLngs() : null;
    },

  },

  methods: {

    polygonReady(polygonComponent) {
      this.$emit('layer-ready', polygonComponent);
      this.polygonComponent = polygonComponent;
      this.map = polygonComponent._map;
      this.map.invalidateSize();
      setTimeout(() => {
        this.centerWithinMap();
      }, 500);
    },

    centerWithinMap() {
      if (this.feature && this.map) {
        this.map.invalidateSize();
        this.$nextTick(() => {
          this.map.flyToBounds(this.layer.getBounds(), {
            maxZoom: 14,
            easeLinearity: 0.1,
          });
          this.polygonComponent.bringToFront();
        });
      }
    },

    goToProvider(feature) {
      const route = {
        name: 'provider-detail',
        params: {
          id: feature.properties.ProviderID,
        },
        query: {
          service: feature.properties.OBJECTID,
          referrer: this.$route.name,
        }
      };
      this.$router.push(route);
    },

  },

};
</script>
